exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AddContentCard-module__wrapper___21lvo{height:100%;border-radius:17px;overflow:hidden;position:relative;display:flex;justify-content:center;align-items:center;background-color:#ececec}.AddContentCard-module__wrapper___21lvo .AddContentCard-module__icons___2TD7K{display:flex;gap:.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "AddContentCard-module__wrapper___21lvo",
	"icons": "AddContentCard-module__icons___2TD7K"
};